const deliveryTimeFragment = /* GraphQL */ `
  fragment deliveryTime on Product {
    deliveryTime: metafield(namespace: "custom", key: "lieferzeit") {
      value
    }
  }
`;

export default deliveryTimeFragment;
